import React from 'react';
import Icon from '../../../components/AppIcon';
import AccountCard from './AccountCard';
import { useNavigate } from 'react-router-dom';

const AccountGroup = ({ title, accounts, onEditAccount, onDeleteAccount }) => {
  const navigate = useNavigate();

  const getCurrencySymbol = () => {
    return '$';
  };

  const displayCurrencySymbol = getCurrencySymbol();

  const formatBalance = (balance) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })?.format(balance);
  };

  if (!accounts || accounts?.length === 0) {
    return (
      <div className="bg-card rounded-lg p-24 border border-border">
        <div className="flex items-center gap-12 mb-16">
          <Icon name="Wallet" size={24} color="var(--color-primary)" />
          <h2 className="text-xl font-heading font-semibold text-card-foreground">{title}</h2>
        </div>
        <p className="text-sm text-muted-foreground">No accounts yet</p>
      </div>
    );
  }

  const totalBalance = accounts?.reduce((sum, acc) => sum + (acc?.balance || 0), 0);

  return (
    <div className="bg-card rounded-lg p-24 border border-border">
      <div className="flex items-center gap-12 mb-20">
        <Icon name="Wallet" size={24} color="var(--color-primary)" />
        <h2 className="text-xl font-heading font-semibold text-card-foreground">{title}</h2>
        <span className="ml-auto text-sm text-muted-foreground">{accounts?.length} account{accounts?.length !== 1 ? 's' : ''}</span>
        <span className="text-sm font-semibold text-foreground">{formatBalance(totalBalance)}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
        {accounts?.map((account) => (
          <AccountCard
            key={account?.id}
            account={account}
            onEdit={onEditAccount}
            onDelete={onDeleteAccount}
            onViewDetails={() => navigate(`/account-details/${account?.id}`)}
          />
        ))}
      </div>
    </div>
  );
};

export default AccountGroup;